const primaryGreen = "#00bf6f";
const secondaryGreen = "#00D3B9";
const primaryText = "#666666";
const white = "#ffffff";

const palette = {
  background: {
    default: "#f5f6f8",
  },
  primary: {
    main: primaryGreen,
    altern: secondaryGreen,
    contrastText: white,
  },
  secondary: {
    main: "#B04FC1",
  },
  warning: {
    main: "#dfd93e", // no hay ejemplo de warning
  },
  success: {
    light: "rgba(0, 191, 111, 0.2)",
    main: primaryGreen,
  },
  error: {
    light: "rgba(223, 47, 45, 0.2)",
    main: "#df2f2d",
  },
  info: {
    light: "rgba(24, 206, 238, 0.2)",
    main: "#18ceee",
  },
  action: {
    main: "#224d55", // sidebar selected item
  },
  change: {
    main: "#ccf2e2",
  },
  text: {
    primary: primaryText,
    secondary: white,
    tertiary: primaryGreen,
  },
  buttonDefault: {
    text: primaryText,
    main: "#b6b4b542",
    dark: "#dde3e7c0", // no hay ejemplo de dark
  },
  buttonPrimary: {
    text: white,
    main: "#b04fc1",
    dark: "#b041A3", // no hay ejemplo de dark
  },
};

export default palette;
